import { DefaultImageProps } from './types';
import { TWITTER_IMAGE_URL } from './urls';

export const TwitterImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={TWITTER_IMAGE_URL}
    alt="twitter"
    {...props}
  />
);
